module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/3@2x_b195922f17c2cba20352e70b545f8a83.png";